/**
 * Mega Menu — JavaScript
 *
 * Desktop: per-item hover/focus open with a shared close timer, so moving
 *   the pointer between top-level items swaps flyouts instantly. Click
 *   toggles the current item (useful for touch + keyboard).
 * Mobile: the [data-mega-mobile] drawer slides in when the header
 *   hamburger [data-menu-toggle] is clicked (capture-phase intercept so
 *   we fire before the jQuery NavMobile handler). Inside the drawer each
 *   top-level item is an accordion group.
 */
(function () {
  'use strict';

  var CLOSE_DELAY = 150; // ms

  function initDesktop(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mega-item]'));
    if (!items.length) return;

    var closeTimer = null;
    var openItem = null;

    function setItemState(item, isOpen) {
      item.classList.toggle('is-open', isOpen);
      var trigger = item.querySelector('[data-mega-trigger]');
      var flyout = item.querySelector('[data-mega-flyout]');
      if (trigger) trigger.setAttribute('aria-expanded', String(isOpen));
      if (flyout)  flyout.setAttribute('aria-hidden', String(!isOpen));
    }

    function openNow(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openItem && openItem !== item) setItemState(openItem, false);
      setItemState(item, true);
      openItem = item;
    }

    function closeNow(item) {
      setItemState(item, false);
      if (openItem === item) openItem = null;
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (openItem) closeNow(openItem);
        closeTimer = null;
      }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-mega-trigger]');
      var flyout = item.querySelector('[data-mega-flyout]');
      if (!trigger || !flyout) return; // plain link item, no dropdown

      item.addEventListener('mouseenter', function () { openNow(item); });
      item.addEventListener('mouseleave', scheduleClose);

      trigger.addEventListener('focus', function () { openNow(item); });
      /*
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('is-open')) {
          closeNow(item);
        } else {
          openNow(item);
        }
      });
       */
    });

    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) closeNow(openItem);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        closeNow(openItem);
        var trigger = openItem && openItem.querySelector('[data-mega-trigger]');
        if (trigger) trigger.focus();
      }
    });
  }

  function initMobileAccordion(drawer) {
    var groups = drawer.querySelectorAll('[data-mega-mobile-group]');
    groups.forEach(function (group) {
      var toggle = group.querySelector('[data-mega-mobile-group-toggle]');
      var panel = group.querySelector('[data-mega-mobile-group-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        panel.setAttribute('aria-hidden', String(!isOpen));
      });
    });
  }

  function initMobileDrawer(section) {
    var drawer = section.querySelector('[data-mega-mobile]');
    var menuToggle = document.querySelector('[data-menu-toggle]');
    if (!drawer || !menuToggle || menuToggle._mmDrawerBound) return;
    menuToggle._mmDrawerBound = true;

    var overlay = document.createElement('div');
    overlay.className = 'mega-menu__mobile-overlay';
    document.body.appendChild(overlay);

    var drawerOpen = false;
    var ANIM_IN_MS = 400;
    var ANIM_OUT_MS = 200;

    function setDrawerHeight() {
      drawer.style.height = window.innerHeight + 'px';
    }

    function openDrawer() {
      if (drawerOpen) return;
      drawerOpen = true;
      setDrawerHeight();
      document.body.classList.add('scroll-lock');
      overlay.classList.remove('mm-hiding');
      overlay.classList.add('mm-visible');
      drawer.classList.add('mm-animating', 'mm-animating-in');
      setTimeout(function () {
        drawer.classList.remove('mm-animating', 'mm-animating-in');
        drawer.classList.add('mm-visible');
      }, ANIM_IN_MS);
    }

    function closeDrawer() {
      if (!drawerOpen) return;
      drawerOpen = false;
      drawer.classList.remove('mm-visible');
      drawer.classList.add('mm-animating', 'mm-animating-out');
      overlay.classList.remove('mm-visible');
      overlay.classList.add('mm-hiding');
      setTimeout(function () {
        drawer.classList.remove('mm-animating', 'mm-animating-out');
        overlay.classList.remove('mm-hiding');
        document.body.classList.remove('scroll-lock');
      }, ANIM_OUT_MS);
    }

    // Capture phase: fire before jQuery's bubble-phase NavMobile handler.
    menuToggle.addEventListener('click', function (e) {
      if (window.innerWidth >= 1024) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      drawerOpen ? closeDrawer() : openDrawer();
    }, true);

    overlay.addEventListener('click', closeDrawer);

    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerOpen) closeDrawer();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 1024 && drawerOpen) {
        drawer.classList.remove('mm-animating', 'mm-animating-in', 'mm-animating-out', 'mm-visible');
        overlay.classList.remove('mm-visible', 'mm-hiding');
        document.body.classList.remove('scroll-lock');
        drawerOpen = false;
      } else if (drawerOpen) {
        setDrawerHeight();
      }
    });
  }

  function initSection(section) {
    var root = section.querySelector('[data-mega-root]');
    if (root) initDesktop(root);

    var drawer = section.querySelector('[data-mega-mobile]');
    if (drawer) {
      initMobileAccordion(drawer);
      initMobileDrawer(section);
    }
  }

  function init() {
    document.querySelectorAll('[data-mega-menu]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sections = e.target.querySelectorAll('[data-mega-menu]');
    sections.forEach(initSection);
  });
})();
